import {
	type UseTitleGenerationOnPasteProps,
	useTitleGenerationOnPaste,
} from './hooks/useTitleGenerationOnPaste.tsx';

export const TitleGenerationOnPaste = ({
	contentId,
	textAreaRef,
	title,
	isLivePage,
	isEditorEmpty,
	userOffline,
	flags,
	i18n,
	formatMessage,
	onTitleGenerated,
	onTitleGeneratingChange,
}: UseTitleGenerationOnPasteProps) => {
	useTitleGenerationOnPaste({
		contentId,
		textAreaRef,
		title,
		isLivePage,
		isEditorEmpty,
		userOffline,
		flags,
		i18n,
		formatMessage,
		onTitleGenerated,
		onTitleGeneratingChange,
	});

	return null;
};
